<template>
  <div class="denomination-search-wrapper flex flex-row" :class="`bg-${color}`">
    <denomination-on-icn
      style="position: absolute;text-align: center; margin: 10px;"
      width="20px"
      height="20px"
      class="white-icon"
    >
    </denomination-on-icn>

    <Listbox v-model="selectedDenomination" v-slot="{ open }">
      <div class="relative mx-auto my-auto">
        <ListboxButton
          class="relative w-full py-2 pl-3 pr-10 text-left bg-white rounded-full shadow-md cursor-default focus:outline-none focus-visible:ring-white  sm:text-sm"
          style="width: 416px; padding-bottom: 2px; padding-top: 2px;"
        >
          <span
            class="block truncate text-lg"
            :class="selectedDenomination ? `text-${color}` : 'text-gray-500'"
            >{{
              selectedDenomination
                ? selectedDenomination.name
                : '会派を選択してください'
            }}
          </span>
          <span
            class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
          >
            <chevron-icn
              width="20px"
              height="20px"
              :class="`${color}-icon`"
              :style="open ? 'transform: rotate(180deg)' : ''"
            ></chevron-icn>
          </span>
        </ListboxButton>

        <transition
          leave-active-class="transition duration-100 ease-in"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <ListboxOptions
            class="absolute w-full py-1 mt-2 overflow-auto text-base bg-white shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
            style="border-radius: 20px; outline: 2px solid white; outline-offset: 0; padding-left: 2px; padding-right: 2px; z-index: 1;"
            :class="`border-4 border-${color}`"
          >
            <ListboxOption
              v-slot="{ active, selected }"
              v-for="denomination in denominationsTop"
              :key="denomination.detail.id"
              :value="denomination.detail"
              as="template"
            >
              <li
                :class="[
                  active ? `bg-${color} text-white active` : `text-${color}`,
                  'cursor-default select-none relative pl-8',
                ]"
                style="height: 28px;"
              >
                <denomination-off-icn
                  width="20px"
                  height="18px"
                  class="absolute inset-y-0 left-0 flex items-center hover-white-icon"
                  style="margin: auto; margin-left: 8px;"
                  fill-rule="evenodd"
                  :fill="
                    `${color}` === 'purple'
                      ? '#a068e0'
                      : `${color}` === 'blue'
                      ? '#2993CE'
                      : `${color}` === 'green'
                      ? '#549A1D'
                      : ''
                  "
                >
                </denomination-off-icn>

                <span
                  :class="[
                    selected ? 'font-medium' : 'font-normal',
                    'block truncate text-lg',
                  ]"
                  >{{ denomination.detail.name }}</span
                >
              </li>
            </ListboxOption>
          </ListboxOptions>
        </transition>
      </div>
    </Listbox>

    <clear-icn
      class="clear-icon"
      :class="`${color}-icon`"
      width="20px"
      height="20px"
      @click="clearSelect"
      v-show="selectedDenomination"
    ></clear-icn>
  </div>
</template>
<script>
import { onMounted, onUnmounted, watch } from 'vue'
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from '@headlessui/vue'
import ClearIcn from '@/assets/icons/clear.svg?inline'
import ChevronIcn from '@/assets/icons/chevron.svg?inline'
import DenominationOnIcn from '@/assets/icons/denomination-on.svg?inline'
import DenominationOffIcn from '@/assets/icons/denomination-off.svg?inline'
import { useDenominationSelect } from '@/services/useDenominationSelect'
import { useDenominations } from '@/services/useDenominations'

export default {
  name: 'AppDownloadSearche',

  components: {
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
    ClearIcn,
    ChevronIcn,
    DenominationOnIcn,
    DenominationOffIcn,
  },

  props: {
    color: {
      type: String,
      default: '',
    },
  },

  setup() {
    const { selectedDenomination, clearSelect } = useDenominationSelect()
    const { denominationsTop, getDenominations } = useDenominations()

    onMounted(async () => {
      await getDenominations()
    })

    onUnmounted(() => {
      clearSelect()
    })

    watch(async () => {
      await getDenominations()
    })

    return { denominationsTop, selectedDenomination, clearSelect }
  },
}
</script>
<style lang="scss" scoped>
.denomination-search-wrapper {
  position: relative;
  width: 488px;
  min-width: 488px;
  height: 40px;
  box-sizing: border-box;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;

  svg.clear-icon {
    position: absolute;
    right: 0px;
    margin: 10px;
  }
}

li.active {
  border-radius: 22px;
  .hover-white-icon {
    fill: #ffffff;
  }
}
</style>
